import {
  BookingMessageTemplate,
  BookingMessageTemplateCategory,
  type BookingMessageTemplateRecord,
  type LanguageCode
} from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';
import type { BadgeVariant } from 'noddi-ui-web';

export const BOOKING_MESSAGE_TEMPLATE_NAMES: Record<BookingMessageTemplate, string> = {
  [BookingMessageTemplate.RUNNING_LATE]: 'Running late',
  [BookingMessageTemplate.LATE_ABOUT_AN_HOUR]: 'Late, about an hour',
  [BookingMessageTemplate.VEHICLE_TROUBLE]: 'Vehicle trouble',
  [BookingMessageTemplate.DIFFICULT_ROADS]: 'Difficult roads',
  [BookingMessageTemplate.CANNOT_MAKE_IT_TODAY]: "Can't make it today",
  [BookingMessageTemplate.APOLOGY_DISCOUNT]: 'Discount on this booking',
  [BookingMessageTemplate.APOLOGY_DISCOUNT_NEXT_BOOKING]: 'Discount on next booking',
  [BookingMessageTemplate.ARRIVING_EARLY]: 'Arriving early',
  [BookingMessageTemplate.CAR_ACCESS]: 'Car access'
};

export const BOOKING_MESSAGE_TEMPLATE_CATEGORIES: Record<
  BookingMessageTemplateCategory,
  { label: string; variant: BadgeVariant; icon: NoddiIconName }
> = {
  [BookingMessageTemplateCategory.DELAY]: { label: 'Delay', variant: 'warning', icon: 'Clock' },
  [BookingMessageTemplateCategory.APOLOGY]: { label: 'Apology', variant: 'success', icon: 'Gift' },
  [BookingMessageTemplateCategory.INFO]: { label: 'Info', variant: 'info', icon: 'Info' }
};

/** A template that fits the situation, with the reason it fits. */
export type BookingMessageTemplateSuggestion = { template: BookingMessageTemplate; reason: string };

export const bookingMessageTemplateBody = (template: BookingMessageTemplateRecord, languageCode: LanguageCode) =>
  template.bodies.find((body) => body.languageCode === languageCode)?.body ?? '';

/** The template's text in each language a message is written in. */
export const bookingMessageTemplateBodies = (
  template: BookingMessageTemplateRecord,
  languageCodes: LanguageCode[]
): Partial<Record<LanguageCode, string>> =>
  Object.fromEntries(
    languageCodes.map((languageCode) => [languageCode, bookingMessageTemplateBody(template, languageCode)])
  );
